import React from 'react';
import '../styles/GroupCallJoinBar.css';

const GroupCallJoinBar = ({ call, onJoin, joining = false }) => {
  if (!call?.groupCallId) return null;

  const isVideo = call.callType === 'video';
  const count = Number(call.participantCount) || (call.participantIds || []).length || 0;
  const peopleLabel = count === 1 ? '1 person in call' : `${count} people in call`;

  return (
    <div className="group-call-join-bar" role="status" aria-label="Ongoing group call">
      <div className="group-call-join-info">
        <span className="group-call-join-icon" aria-hidden="true">
          {isVideo ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="23 7 16 12 23 17 23 7" />
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
            </svg>
          )}
        </span>
        <div className="group-call-join-copy">
          <span className="group-call-join-title">
            Ongoing group {isVideo ? 'video' : 'audio'} call
          </span>
          <span className="group-call-join-meta">{peopleLabel}</span>
        </div>
      </div>
      <button
        type="button"
        className="group-call-join-btn"
        onClick={onJoin}
        disabled={joining}
      >
        {joining ? 'Joining…' : 'Join'}
      </button>
    </div>
  );
};

export default GroupCallJoinBar;
